/**
* 酒店管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客房管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="search">
      <el-form-item label="搜索：">
        <el-select v-model="formInline.hotelId" filterable  clearable placeholder="请选择" style="width:300px">
          <el-option v-for="item in hotelSelect" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="roomAdd()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="roomData" highlight-current-row v-loading="loading"  border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" sortable prop="hotelName" label="酒店名称" width="120"/>
      <el-table-column align="center" sortable prop="bedType" label="床型" min-width="50" :formatter="badTypeFormat"></el-table-column>
      <el-table-column align="center" sortable prop="storey" label="每日可售房数"  width="120"/>
    <!--  <el-table-column align="center" sortable prop="area" label="面积"/>-->
      <el-table-column align="center" sortable prop="peoples" label="可住人数" />
      <el-table-column align="center" sortable prop="breakfast" label="早餐" :formatter="breakfastFormat"/>
      <el-table-column align="center" sortable prop="originalPrice" label="携程卖价"/>
      <el-table-column align="center" sortable prop="discountPrice" label="平台卖价"/>
      <el-table-column align="center" sortable prop="roomStatus" label="状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.roomStatus=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="roomStatusChange(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="checkInTime" label="最早入住时间"/>
      <!--<el-table-column align="center" sortable prop="updateTime" label="修改时间" min-width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime|timestampToTime }}</div>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="roomEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="roomDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 新增编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @close='closeDialog("edit")'>
      <el-form label-width="100px" ref="editForm" :model="editForm" :rules="rules" >
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="酒店名称" prop="hotelId">
                <el-select  v-model="editForm.hotelId" clearable placeholder="请选择" @change="changeHotel"  size="medium" style="width: 93%">
                  <el-option v-for="item in hotelSelect" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="床型" prop="bedType">
                <el-select v-model="editForm.bedType" placeholder="请选择"  size="medium" style="width: 93%">
                  <el-option v-for="item in roomInfo" :key="item.label"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="面积" prop="area">
                <el-input-number v-model="editForm.area" :min="0" :max="100" :step="0.1" label="面积"size="medium"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="可住人数" prop="peoples">
                <el-input-number v-model="editForm.peoples" :min="1" :max="5" label="可住人数"size="medium"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="携程卖价" prop="originalPrice">
                <el-input-number v-model="editForm.originalPrice" label="携程卖价" @change="getOriginal" size="medium"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="平台卖价" prop="discountPrice">
                <el-input-number v-model="editForm.discountPrice" label="平台卖价" :disabled="true" size="medium"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="早餐" prop="breakfast">
                <el-switch  v-model="editForm.breakfast" active-color="#13ce66"  inactive-color="#ff4949">  </el-switch>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="是否有窗" prop="hasWindow">
                <el-switch  v-model="editForm.hasWindow" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="每日可售房数" prop="storey">
                <el-input-number v-model="editForm.storey" :min="1" label="客房数量" size="medium"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="最早入住时间" prop="storey">
                <el-input v-model="editForm.checkInTime" value="20:00" disabled></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-form-item label="客房简介" prop="rootIntro" >
          <el-input v-model="editForm.rootIntro" type="textarea" :rows="3"  placeholder="客房简介" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            class="upload-demo"
            action="/api/business/image/uploadImage"
            accept="image/jpeg,image/jpg,image/png"
            multiple
            :on-remove="handleRemove"
            :http-request="UploadFile"
            :file-list="editForm.fileList"
            list-type="picture-card">
            <el-button size="small" type="primary">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpeg/jpg/png文件</div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 导入请求方法
  import {
    hotelSelect
  } from '../../api/hotelMg'
  import {
    roomList,
    roomSave,
    roomEdit,
    roomDelete,
    roomStatusEdit
  } from '../../api/roomMg'
  import Pagination from '../../components/Pagination'
  import {userEdit} from "../../api/userMG";

  export default {
    data() {
      // 请求数据参数
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        title: '添加客房信息',
        editFormVisible: false, //控制编辑页面显示与隐藏
        roomInfo: [
         {
            value: "Twin",
            label: "标间"
          }, {
            value: "Double",
            label: "大床"
          }
        ],
        // 编辑与添加
        editForm: {
          id: '',
          hotelId: '',
          area: 0,
          peoples: 0,
          bedType: '',
          breakfast: true,
          storey: 0,//客房数量
          rootIntro:'',
          roomStatus:'',
          hasWindow:true,
          originalPrice:0,//原价
          discountPrice:0,//折扣价
          fileList: [],
          discount:10,
          checkInTime:'20:00',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          pageNum: 1,
          pageSize: 10,
          hotelId: ''
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //列表数据
        roomData: [],
        //下拉列表数据
        hotelSelect:[],
        rules: {
          hotelId: [{required: true, message: '请选择所属酒店', trigger: 'blur'} ],
          bedType: [{required: true, message: '请选择房间床型', trigger: 'blur'}],
          remark: [{required: true, message: '请选择酒店详情', trigger: 'blur'}]
        },
        fileList: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    computed:{
      //计算属性
    },
    /**
     * 数据发生改变
     */
    watch: {},
    /**
     * 创建完毕,初始化数据
     */
    created() {
      this.queryHotelList()
      this.getdata(this.formInline)
    },
    methods: {
      getdata(parameter) {
        //获取客房列表
        roomList(parameter).then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.roomData = res.result.rows
            // 分页赋值
            this.pageparm.currentPage = res.result.pagination.current
            this.pageparm.pageSize = res.result.pagination.pageSize
            this.pageparm.total = res.result.pagination.total
          }
        })
      },
      //搜索事件
      search() {
        this.getdata(this.formInline)
      },
      roomAdd: function (index, row) {
        this.editFormVisible = true
        this.title = '添加客房信息'
        this.editForm.id = ''
        this.editForm.hotelId = ''
        this.editForm.area = 0
        this.editForm.peoples = 0
        this.editForm.bedType = ''
        this.editForm.breakfast = true
        this.editForm.storey=1
        this.editForm.rootIntro=''
        this.editForm.originalPrice=0
        this.editForm.discountPrice=0
      },
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      UploadFile(param) {
        var data = new FormData();
        data.append("file", param.file);
        var config = {
          headers: {'Content-Type': 'multipart/form-data', token: localStorage.getItem('logintoken')}
        }
        this.$axios.post(param.action, data, config).then((res) => {
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            //数组只赋值字符串url，无法自动传教uid，删除时无法处理，此处传对象
            let obj = new Object();
            obj.url="https://hotel.leikl.com/images/"+res.data.result;
            this.editForm.fileList.unshift(obj);
          }
        })
      },
      // 关闭编辑、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        }
        this.editForm.fileList=[]
        this.$refs['editForm'].resetFields();
      },
      handleRemove(file) {
        let index= this.editForm.fileList.findIndex(fileItem =>{
          return fileItem.uid === file.uid;
        });
        this.editForm.fileList.splice(index,1);
      },
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            if(this.editForm.fileList){
              let newFileList = this.editForm.fileList.map(obj=>{return obj.url})
              this.editForm.fileList = newFileList;
            }
            if (this.editForm.id == undefined || this.editForm.id.length <= 0) {
              //图片数组对象处理,只取url丢到后台

              // 新增用户信息
              roomSave(this.editForm)
                .then(res => {
                  this.editFormVisible = false
                  this.loading = false
                  if (res.success) {
                    this.getdata(this.formInline)
                    this.$message({
                      type: 'success',
                      message: '数据保存成功！'
                    })
                    this.$refs['editForm'].resetFields();
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.message
                    })
                  }
                })
                .catch(err => {
                  this.editFormVisible = false
                  this.loading = false
                  this.$message.error('保存失败，请稍后再试！')
                })
            } else {
              roomEdit(this.editForm)
                .then(res => {
                  this.editFormVisible = false
                  this.loading = false
                  if (res.success) {
                    this.getdata(this.formInline)
                    this.$message({
                      type: 'success',
                      message: '数据保存成功！'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.message
                    })
                  }
                })
            }
          } else {
            return false
          }
        })
      },
      // 删除酒店信息
      roomDelete(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除
          roomDelete({ids: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
      roomEdit: function (index, row) {
        this.editFormVisible = true;
        this.title = '修改客房信息';
        this.editForm.id = row.id;
        this.editForm.hotelId = row.hotelId;
        this.editForm.bedType = row.bedType
        this.editForm.area = row.area;
        this.editForm.peoples = row.peoples;
        this.editForm.storey = row.storey;
        this.editForm.discountPrice = row.discountPrice;
        this.editForm.originalPrice = row.originalPrice;
        this.editForm.hasWindow = row.hasWindow=="true"?true:false;
        this.editForm.breakfast = row.breakfast=="true"?true:false;
        this.editForm.rootIntro = row.rootIntro;
        this.editForm.roomStatus = row.roomStatus;
        this.editForm.checkInTime = row.checkInTime;
        if (row.fileList != null && row.fileList.length > 0){
          row.fileList.forEach(item=>{
            let obj = new Object();
            obj.url = "https://hotel.leikl.com/images/"+item;
            this.editForm.fileList.push(obj);
          })
        }
      },
      queryHotelList: function () {
        hotelSelect().then(res =>{
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
           res.result.forEach(item =>{
             this.hotelSelect.push(item);
           })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: res.message
          })
        })

      },
      getOriginal(value) {
        //折扣价修改方法
        if(this.editForm.hotelId){
          const hotelId = this.editForm.hotelId;
          this.hotelSelect.forEach(res=>{
            if(res.id == hotelId){
              //酒店折扣
              this.editForm.discount = res.discount;
            }
          })
          if(this.editForm.discount){
            //获取折扣
            const discount = this.editForm.discount / 10;
            //根据折扣价算出折扣价
            this.editForm.discountPrice=Math.ceil(value*discount);
          }else{
            this.editForm.discountPrice=value;
          }
        }else{
          this.editForm.discountPrice=value;
        }

      },
      changeHotel(value){
        //下拉列表改变获取到全部值
        this.hotelSelect.forEach(res=>{
          if(res.id == value){
           this.editForm.discount = res.discount
          }
        })

        //设置原价信息
        if(this.editForm.discountPrice>0){
          if(this.editForm.discount>0){
            //获取折扣
            const discount = this.editForm.discount / 10;
            //根据折扣价算出原价
            this.editForm.originalPrice=Math.ceil(this.editForm.discountPrice/discount);
          }
        }else{
          this.editForm.originalPrice=0
        }
      },
      badTypeFormat(row,column){
        if(row.bedType=='Single'){
          return "单人间"
        }else if(row.bedType=='Twin'){
          return  "标间"
        }else if(row.bedType=='Double'){
          return "大床"
        }
      },
      breakfastFormat(row){
        if(row.breakfast=='true'){
          return "含早餐"
        }else{
          return "不含早餐"
        }
      },
      roomStatusChange: function(index, row) {
        this.loading = true
        let parm = {
          roomStatus: '',
          id: '',
          token: localStorage.getItem('logintoken')
        }
        parm.id = row.id
        let status = row.roomStatus
        if (status == '1') {
          parm.roomStatus = '2'
        } else {
          parm.roomStatus = '1'
        }
        // 修改状态
        roomStatusEdit(parm).then(res => {
          this.loading = false
          if (!res.success) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
            this.getdata(this.formInline)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .search {
    margin-top: 20px;
  }
  .bedType-class /deep/ .el-form-item__label{
    width: 61px;
  }
</style>



// WEBPACK FOOTER //
// src/views/hotel/Room.vue